import { NavLink } from "react-router-dom";
import logo from "./logo.png";
import logoPrivncia from "./images/logo-provincia.gif";
import css from "./Menu.module.css";

export default function Menu() {
  return (
    <>
      <nav
        className="navbar navbar-expand-lg navbar-light bg-light"
        aria-label="Offcanvas navbar large"
      >
        <div className="container">
          <NavLink className="navbar-brand" to={"/"}>
            <img src={logo} alt="Museo Antonio Orsini" height="50" />
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="offcanvas offcanvas-end text-bg-light"
            tabIndex={-1}
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            data-bs-dismiss="offcanvas"
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                Museo Antonio Orsini
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              <ul
                className={`navbar-nav mx-auto align-items-lg-center mb-2 mb-lg-0 ${css["customNavbarBtns"]}`}
              >
                <li className="nav-item ms-2">
                  <NavLink className="nav-link" to="/museo">
                    Scopri
                  </NavLink>
                </li>
                <li className="nav-item ms-2">
                  <NavLink className="nav-link" to="/visita">
                    Visita
                  </NavLink>
                </li>
                <li className="nav-item ms-2">
                  <NavLink className="nav-link" to="/antonio-orsini">
                    Orsini
                  </NavLink>
                </li>
              </ul>
              <div className="d-flex justify-content-lg-end">
                <a
                  className="nav-link"
                  href="https://www.provincia.ap.it/"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <img
                    src={logoPrivncia}
                    alt="Provincia Ascoli Piceno"
                    height="50"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
